import { cn } from "@/lib/utils"

export const blockCreateTheme = {
  triggerButton: cn(
    "font-bold text-xl lg:text-2xl px-8 py-6 rounded-3xl shadow-2xl shadow-cyan-500/30 transition-all hover:scale-[1.03]",
    "bg-gradient-to-r from-indigo-600 to-cyan-600 hover:from-indigo-700 hover:to-cyan-700 text-white"
  ),

  dialogContent: "bg-purple-950/70 backdrop-blur-2xl border border-purple-300/40 text-white max-w-2xl max-h-[90vh] overflow-y-auto rounded-3xl",

  formInput: "bg-purple-950/60 border-purple-300/40 focus:border-purple-400 focus:ring-purple-400 text-white rounded-2xl",
  formTextarea: "bg-purple-950/60 border-purple-300/40 focus:border-purple-400 focus:ring-purple-400 text-white rounded-2xl",

  selectTrigger: "bg-purple-950/60 border-purple-300/40 text-white hover:border-purple-400 rounded-2xl",
  selectContent: "bg-purple-950/90 border-purple-300/40 backdrop-blur-2xl text-white shadow-2xl rounded-3xl",

  badgeCoAssignee: "bg-purple-600 text-white",
  badgeObserver: "bg-amber-700/80 text-white",

  fileUploadArea: "flex items-center gap-2 bg-purple-950/60 hover:bg-purple-950/80 text-purple-200 border border-purple-300/40 px-4 py-3 rounded-2xl transition cursor-pointer",

  createButton: "bg-gradient-to-r from-indigo-600 to-cyan-600 hover:from-indigo-700 hover:to-cyan-700 text-white rounded-3xl",
} as const